<!-- <div *ngIf="!isOnMobilePlatform" >
  <div class="alert alert-danger internetNotWorking" *ngIf="!onlineOffline">
    <img src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0nMjAnIGhlaWdodD0nMjAnIHZpZXdCb3g9JzAgMCAyMCAyMCcgeG1sbnM9J2h0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnJz4KCTxnPgoJCTxwYXRoIGQ9J00tMi0yaDI0djI0SC0yeicgZmlsbD0nbm9uZScvPgoJCTxwYXRoIGQ9J00xMCAwQzQuNDggMCAwIDQuNDggMCAxMHM0LjQ4IDEwIDEwIDEwIDEwLTQuNDggMTAtMTBTMTUuNTIgMCAxMCAwem0xIDE1SDl2LTJoMnYyem0wLTRIOVY1aDJ2NnonIGZpbGw9JyNGRjQzNDMnLz4KCTwvZz4KPC9zdmc+Cg==">
    <strong>Your internet is not working !</strong> Please check your internet connection.
  </div>
</div>
<div *ngIf="isOnMobilePlatform" >
  <div class="alert alert-danger internetNotWorking" *ngIf="!onlineOffline" >
    <strong>Your internet is not working !</strong> Please check your Mobile data or WIFI connectivity.
  </div>
</div> -->
<div class="offline-mask" *ngIf="!isOnline && isBrowser">
  <div class="offilne-box">
    <div class="offline-icon">
      <svg class="wifi-svg" viewBox="0 0 100 100">
          <defs>
              <linearGradient id="wifi-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                  <stop offset="0%" style="stop-color:#4b6cb7;stop-opacity:1" />
                  <stop offset="100%" style="stop-color:#182848;stop-opacity:1" />
              </linearGradient>
          </defs>
          <path d="M20,70 A50,50 0 0,1 80,70" />
          <path d="M30,60 A40,40 0 0,1 70,60" />
          <path d="M40,50 A30,30 0 0,1 60,50" />
          <circle cx="50" cy="75" r="5" />
      </svg>
      <div class="slash"></div>
      <div class="glow"></div>
  </div>
    <div  class="offline-banner">
      You are offline. Please check your internet connection.
    </div>
  </div>
</div>

<div >
  <!-- <p-toast position="top-right" [baseZIndex]="5000"></p-toast> -->
<app-header ></app-header>
<main id="main-content" #mainContent  [@visibilityChanged]="o.isActivated && enableAnimation? o.activatedRoute : ''">
<router-outlet #o="outlet" (activate)="onActivate()"></router-outlet>
</main>
<!-- <app-footer></app-footer> -->
  <app-popup-container *ngIf="isBrowser && isAppReady"></app-popup-container>
</div>
